import { render, staticRenderFns } from "./BalanceHistoryModule.vue?vue&type=template&id=54de0a0b&scoped=true"
import script from "./BalanceHistoryModule.vue?vue&type=script&lang=js"
export * from "./BalanceHistoryModule.vue?vue&type=script&lang=js"
import style0 from "./BalanceHistoryModule.vue?vue&type=style&index=0&id=54de0a0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54de0a0b",
  null
  
)

export default component.exports